import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative bg-cream overflow-hidden pt-16 pb-24 lg:pt-24 lg:pb-32" data-id="element-53">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-54">
        <div className="lg:grid lg:grid-cols-12 lg:gap-12 items-center" data-id="element-55">
          <motion.div className="lg:col-span-6 text-center lg:text-left mb-12 lg:mb-0" initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} data-id="element-56">
            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-serif font-bold text-navy-900 leading-tight mb-6" data-id="element-57">
              The <span className="text-gold italic" data-id="element-58">Secure</span> Woman
            </h1>

            <p className="text-xl sm:text-2xl text-navy-800 font-medium mb-6 leading-relaxed" data-id="element-59">
              The 30-Day Protocol to Build Unbreakable Autonomy, Financial
              Security, and Absolute Peace of Mind.
            </p>

            <p className="text-base sm:text-lg text-navy-700 mb-10 leading-relaxed max-w-2xl mx-auto lg:mx-0" data-id="element-60">
              Designed for the modern woman who chooses to own her present and
              architect her own well-being.
            </p>

            <motion.div whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} data-id="element-61">
              <a href="#checkout" className="inline-block w-full sm:w-auto bg-gold hover:bg-gold-bright text-navy-900 font-bold text-lg py-4 px-8 rounded-sm shadow-lg transition-colors duration-300 text-center" data-id="element-62">
                YES, I WANT INSTANT ACCESS FOR $6.39
              </a>
            </motion.div>

            <div className="mt-4 flex items-center justify-center lg:justify-start gap-4 text-sm text-navy-700 font-medium" data-id="element-63">
              <span className="flex items-center gap-1" data-id="element-64">
                <svg className="w-4 h-4 text-gold" fill="currentColor" viewBox="0 0 20 20" data-id="element-65">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-66"></path>
                </svg>
                One-time payment
              </span>
              <span className="flex items-center gap-1" data-id="element-67">
                <svg className="w-4 h-4 text-gold" fill="currentColor" viewBox="0 0 20 20" data-id="element-68">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-69"></path>
                </svg>
                Lifetime access
              </span>
            </div>
          </motion.div>

          <motion.div className="lg:col-span-6 relative" initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} data-id="element-70">
            <div className="relative mx-auto w-full max-w-lg lg:max-w-none" data-id="element-71">
              <div className="absolute -inset-4 bg-gold/20 rounded-full blur-3xl opacity-50" data-id="element-72"></div>
              <img src="https://cdn.magicpatterns.com/uploads/2UArC1zR17xGdTR9ScLpLk/openrouter-generated-image-1775697222143.jpg" alt="The Secure Woman - Book, Tablet and Audio" className="relative z-10 w-full h-auto object-cover rounded-xl shadow-2xl" data-id="element-73" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}